import { put, takeLatest, call } from 'redux-saga/effects';
import ApiCaller from '../ApiCaller';

const callAPI = (payload) => {
  return ApiCaller('/v1/admin/tags', 'GET');
};

export default function* watchRequest() {
  yield takeLatest('TAG_LIST', function* performAction(action) {
    yield put({ type: 'TAG_LIST_INITIATED' });
    try {
      const data = yield call(callAPI.bind(this, action.payload));
      yield put({ type: 'TAG_LIST_SUCCESS', payload: data });
    } catch (error) {
      yield put({ type: 'TAG_LIST_FAILED', payload: error });
    }
  });
}
